<template>
  <svg width="7" height="9" viewBox="0 0 7 9" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4.5L7 0v9z" fill="#231F20" fill-rule="evenodd" />
  </svg>
</template>

<script>
export default {
  name: 'IconTriangleLeft',
};
</script>

<style></style>
